import handleAccordionClick from '/src/components/accordion/accordion';

const faqListRef = document.querySelector('[data-faq-list]');

faqListRef?.addEventListener('click', handleAccordionClick);
